import { version } from './utils/version'

function ContactUs() {
    return (
        <div>
            <p
                style={{
                    marginTop: '50px',
                    color: '#fff',
                    textAlign: 'center'
                }}
            >
                {`Version : ${version}`}
            </p>
        </div>
    )
}

export default ContactUs
